<script setup lang="ts">
import { computed } from 'vue';

import TextCheckOptions from '@/components/Jobs/CopilotActivation/TextCheckOptions.vue';
import ScreenerQuestionsForm from '@/components/Jobs/CopilotActivation/ScreenerQuestionsForm.vue';
import Divider from '@/components/Shared/Divider/Divider.vue';
import PassiveCandidateScreeningCallout from '@/components/Shared/PassiveCandidateScreeningCallout.vue';
import { STICK_TO_SET_QUESTIONS_SUBTITLE } from '@/core/jobs/copilot-activation/screening-copy';

const props = defineProps<{
  isSelected: boolean;
  isPolicyLocked?: boolean;
  isDisabled?: boolean;
  showPassiveCandidateCallout?: boolean;
}>();

const emit = defineEmits<{
  (e: 'select'): void;
}>();

const isOptionLocked = computed(() => props.isDisabled || props.isPolicyLocked);

function handleSelect() {
  if (isOptionLocked.value) {
    return;
  }

  emit('select');
}
</script>

<template>
  <div class="relative" :class="{ 'opacity-75': isOptionLocked }">
    <TextCheckOptions
      :is-selected="isSelected"
      :is-disabled="isOptionLocked"
      :is-policy-locked="isPolicyLocked"
      @click="handleSelect"
    >
      <template #title>Stick to set questions</template>
      {{ STICK_TO_SET_QUESTIONS_SUBTITLE }}

      <template v-if="isSelected" #action>
        <PassiveCandidateScreeningCallout v-if="showPassiveCandidateCallout" class="mb-3" />
        <Divider class="my-3" />
        <ScreenerQuestionsForm :is-disabled="isOptionLocked" />
      </template>
    </TextCheckOptions>
  </div>
</template>
